import * as THREE from "three";
import { TreeData } from "../types";

function createSingleTree(height: number, canopyRadius: number): THREE.Group {
  const tree = new THREE.Group();

  const trunkGeo = new THREE.CylinderGeometry(0.15, 0.2, height, 8);
  const trunkMat = new THREE.MeshStandardMaterial({
    color: 0x8b7355,
    roughness: 0.9,
  });
  const trunk = new THREE.Mesh(trunkGeo, trunkMat);
  trunk.position.y = height / 2;
  trunk.castShadow = true;
  tree.add(trunk);

  const canopyGeo = new THREE.SphereGeometry(canopyRadius, 16, 12);
  canopyGeo.scale(1, 0.75, 1);
  const canopyMat = new THREE.MeshStandardMaterial({
    color: 0x8faa8a,
    roughness: 0.85,
    metalness: 0.0,
  });
  const canopy = new THREE.Mesh(canopyGeo, canopyMat);
  canopy.position.y = height + canopyRadius * 0.5;
  canopy.castShadow = true;
  tree.add(canopy);

  return tree;
}

export function createTree(data: TreeData): THREE.Group {
  const s = data.scale;
  const tree = createSingleTree(2.0 * s, 1.2 * s);
  tree.position.set(...data.position);
  tree.rotation.y = Math.random() * Math.PI * 2;
  return tree;
}
